import findByMatchingProperties from 'utils/find-matching-properties';

export default function passesSingleCheckboxFilter(item, filter) {
    // IF the active filter does not have value or the first value is blank, then we pass the check without question
    if (!filter.values.length || !filter.values[0]) { return true; }

    // Find the filter option on the item that matches the active filter
    const matchedItemFilterOptions = findByMatchingProperties(item.filterOptions, { code: filter.code });

    // if we did not find a match, then this item does not pass the filtering
    if (!matchedItemFilterOptions || !matchedItemFilterOptions.length) { return false; }

    // then check if all matched filter options have a match between their values array and the filter's values
    // if the array returned by intersection() has a length greater than zero, than it means there's a match
    const noMatch = matchedItemFilterOptions.find(option => !option.values.includes(filter.values[0]));
    return noMatch === undefined;
}
